// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2IcLg","messages":"Chat_messages__3krTF","dateDivider":"Chat_dateDivider__1mbPJ"};